import type { LoaderFunction } from 'react-router-dom'

import { Outlet } from 'react-router-dom'

import Nav from '../Nav/Nav'

import allTrackData from '../../data/allTrackData'

import './App.css'

export interface LoaderData {
  doneLoading?: true
  allTrackData: typeof allTrackData
}

export const loader: LoaderFunction = async function () : Promise<LoaderData> {
  return {
    doneLoading: true,
    allTrackData,
  }
}

export default function App () {
  return (
    <div className='app'>
      <Nav/>
      <div>
        <Outlet/>
      </div>
    </div>
  )
}
